export default __webpack_public_path__ + "static/media/star.21477acc.svg";